import React from 'react';

function TableRows({rowsData, deleteTableRows, handleChange}) {
    return(
        
    rowsData.map((data, index)=>{

        const {partNumber,reasonForScrap,quantity,PO_SA_Number,QN_RFA_Number,serialNumber}= data;

    return(
        <tr key={index}>
            <td>{index+1}</td>
            <td>
                <input type="text" value={partNumber} onChange={(evnt)=>(handleChange(index, evnt))} name="partNumber" class="form-control" required/>
            </td>
                        <td>
                                {(() => {
                                    // Define the options as value/label pairs, with 'Other' last
                                    const reasonOptions = [
                                        { value: "Engineering Change", label: "Engineering Change" },
                                        { value: "Excess/Obsolete", label: "Excess/Obsolete" },
                                        { value: "Latent Defect", label: "Latent Defect" },
                                        { value: "Producibility", label: "Producibility" },
                                        { value: "eQN/QN", label: "eQN/QN" },
                                        { value: "eQuest/QN", label: "eQuest/QN" },
                                        { value: "Tooling", label: "Tooling" },
                                        { value: "Obvious Scrap", label: "Obvious Scrap" },
                                        { value: "Machining failure", label: "Machining failure" },
                                        { value: "Other (specify in comments field)", label: "Other (specify in comments field)" }
                                    ];
                                    // Sort all except 'Other' by label
                                    const otherOption = reasonOptions.find(opt => opt.value === "Other (specify in comments field)");
                                    const sortedOptions = reasonOptions
                                        .filter(opt => opt.value !== "Other (specify in comments field)")
                                        .sort((a, b) => a.label.localeCompare(b.label));
                                    if (otherOption) sortedOptions.push(otherOption);
                                    return (
                                        <select id="reasonForScrap" name="reasonForScrap" onChange={(evnt)=>(handleChange(index, evnt))} value={reasonForScrap} class="form-control" required>
                                            <option value="">-- Please Select --</option>
                                            {sortedOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    );
                                })()}
                        </td>
            <td>
                <input type="number" value={quantity}  onChange={(evnt)=>(handleChange(index, evnt))} name="quantity" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={PO_SA_Number}  onChange={(evnt)=>(handleChange(index, evnt))} name="PO_SA_Number" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={QN_RFA_Number}  onChange={(evnt)=>(handleChange(index, evnt))} name="QN_RFA_Number" class="form-control" required/> 
            </td>
            <td>
                <input type="text" value={serialNumber}  onChange={(evnt)=>(handleChange(index, evnt))} name="serialNumber" class="form-control" required/> 
            </td>
            <td>
                <button class="btn btn-outline-danger" onClick={()=>(deleteTableRows(index))}>x</button>
            </td>
        </tr>
            )
        })
   
    )
    
}
export default TableRows;